export const FETCH_ACCOUNT_MAXES_START = 'FETCH_ACCOUNT_MAXES_START';
export const FETCH_ACCOUNT_MAXES_FULFILLED = 'FETCH_ACCOUNT_MAXES_FULFILLED';
export const FETCH_ACCOUNT_MAXES_REJECTED = 'FETCH_ACCOUNT_MAXES_REJECTED';

export const FETCH_ACCOUNT_GOALS_START = 'FETCH_ACCOUNT_GOALS_START';
export const FETCH_ACCOUNT_GOALS_FULFILLED = 'FETCH_ACCOUNT_GOALS_FULFILLED';
export const FETCH_ACCOUNT_GOALS_REJECTED = 'FETCH_ACCOUNT_GOALS_REJECTED';

export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_FULFILLED = 'FETCH_GROUPS_FULFILLED';
export const FETCH_GROUPS_REJECTED = 'FETCH_GROUPS_REJECTED';

export const FETCH_CALENDARS_START = 'FETCH_CALENDARS_START';
export const FETCH_CALENDARS_FULFILLED = 'FETCH_CALENDARS_FULFILLED';
export const FETCH_CALENDARS_REJECTED = 'FETCH_CALENDARS_REJECTED';

export const FETCH_ATHLETES_START = 'FETCH_ATHLETES_START';
export const FETCH_ATHLETES_FULFILLED = 'FETCH_ATHLETES_FULFILLED';
export const FETCH_ATHLETES_REJECTED = 'FETCH_ATHLETES_REJECTED';

export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';

export const CREATE_MAX_EFFORT_START = 'CREATE_MAX_EFFORT_START';
export const CREATE_MAX_EFFORT_FULFILLED = 'CREATE_MAX_EFFORT_FULFILLED';
export const CREATE_MAX_EFFORT_REJECTED = 'CREATE_MAX_EFFORT_REJECTED';

export const SAVE_GOAL_START = 'SAVE_GOAL_START';
export const SAVE_GOAL_FULFILLED = 'SAVE_GOAL_FULFILLED';
export const SAVE_GOAL_REJECTED = 'SAVE_GOAL_REJECTED';

export const DELETE_GOALS_START = 'DELETE_GOALS_START';
export const DELETE_GOALS_FULFILLED = 'DELETE_GOALS_FULFILLED';
export const DELETE_GOALS_REJECTED = 'DELETE_GOALS_REJECTED';

export const FETCH_MAX_HISTORY_START = 'FETCH_MAX_HISTORY_START';
export const FETCH_MAX_HISTORY_FULFILLED = 'FETCH_MAX_HISTORY_FULFILLED';
export const FETCH_MAX_HISTORY_REJECTED = 'FETCH_MAX_HISTORY_REJECTED';

export const FETCH_HISTORY_CURRENT_MAX_START = 'FETCH_HISTORY_CURRENT_MAX_START';
export const FETCH_HISTORY_CURRENT_MAX_FULFILLED = 'FETCH_HISTORY_CURRENT_MAX_FULFILLED';
export const FETCH_HISTORY_CURRENT_MAX_REJECTED = 'FETCH_HISTORY_CURRENT_MAX_REJECTED';

export const SET_MAX_ACTIVE_START = 'SET_MAX_ACTIVE_START';
export const SET_MAX_ACTIVE_FULFILLED = 'SET_MAX_ACTIVE_FULFILLED';
export const SET_MAX_ACTIVE_REJECTED = 'SET_MAX_ACTIVE_REJECTED';

export const ARCHIVE_MAX_START = 'ARCHIVE_MAX_START';
export const ARCHIVE_MAX_FULFILLED = 'ARCHIVE_MAX_FULFILLED';
export const ARCHIVE_MAX_REJECTED = 'ARCHIVE_MAX_REJECTED';

export const SET_MAXES_LOCK_START = 'SET_MAXES_LOCK_START';
export const SET_MAXES_LOCK_FULFILLED = 'SET_MAXES_LOCK_FULFILLED';
export const SET_MAXES_LOCK_REJECTED = 'SET_MAXES_LOCK_REJECTED';

export const RESET_MAXES_START = 'RESET_MAXES_START';
export const RESET_MAXES_FULFILLED = 'RESET_MAXES_FULFILLED';
export const RESET_MAXES_REJECTED = 'RESET_MAXES_REJECTED';

export const BULK_ARCHIVE_MAXES_START = 'BULK_ARCHIVE_MAXES_START';
export const BULK_ARCHIVE_MAXES_FULFILLED = 'BULK_ARCHIVE_MAXES_FULFILLED';
export const BULK_ARCHIVE_MAXES_REJECTED = 'BULK_ARCHIVE_MAXES_REJECTED';

export const SET_MAXES_GOALS_FILTER = 'SET_MAXES_GOALS_FILTER';
